/* eslint-disable */

import React from 'react';

export const Feature00DataSource = {
    wrapper: {className: 'home-page-wrapper content0-wrapper'},
    page: {className: 'home-page content0'},
    OverPack: {playScale: 0.3, className: ''},
    titleWrapper: {
        className: 'title-wrapper',
        children: [
            {
                name: 'title',
                children: (
                    <>
                        <p>企业优势/Company Profile&nbsp;</p>
                    </>
                ),
            },
        ],
    },
    childWrapper: {
        className: 'content0-block-wrapper',
        children: [
            {
                name: 'block0',
                className: 'content0-block',
                md: 8,
                xs: 24,
                children: {
                    className: 'content0-block-item',
                    children: [
                        {
                            name: 'image',
                            className: 'content0-block-icon',
                            children:
                                'https://zos.alipayobjects.com/rmsportal/WBnVOjtIlGWbzyQivuyq.png',
                        },
                        {
                            name: 'title',
                            className: 'content0-block-title',
                            children: '一站式业务接入',
                        },
                        {name: 'content', children: '支付、结算、核算接入产品效率翻四倍'},
                    ],
                },
            },
            {
                name: 'block1',
                className: 'content0-block',
                md: 8,
                xs: 24,
                children: {
                    className: 'content0-block-item',
                    children: [
                        {
                            name: 'image',
                            className: 'content0-block-icon',
                            children:
                                'https://zos.alipayobjects.com/rmsportal/YPMsLQuCEXtuEkmXTTdk.png',
                        },
                        {
                            name: 'title',
                            className: 'content0-block-title',
                            children: '一站式事中风险监控',
                        },
                        {
                            name: 'content',
                            children: '在所有需求配置环节事前风险控制和质量控制能力',
                        },
                    ],
                },
            },
            {
                name: 'block2',
                className: 'content0-block',
                md: 8,
                xs: 24,
                children: {
                    className: 'content0-block-item',
                    children: [
                        {
                            name: 'image',
                            className: 'content0-block-icon',
                            children:
                                'https://zos.alipayobjects.com/rmsportal/EkXWVvAaFJKCzhMmQYiX.png',
                        },
                        {
                            name: 'title',
                            className: 'content0-block-title',
                            children: '一站式数据运营',
                        },
                        {
                            name: 'content',
                            children: '沉淀产品接入效率和运营小二工作效率数据',
                        },
                    ],
                },
            },
        ],
    },
};
export const Content50DataSource = {
    wrapper: {className: 'home-page-wrapper content5-wrapper'},
    page: {className: 'home-page content5'},
    OverPack: {playScale: 0.3, className: ''},
    titleWrapper: {
        className: 'title-wrapper',
        children: [
            {
                name: 'title',
                children: (
                    <>
                        <p>资质荣誉/Company Profile</p>
                    </>
                ),
                className: 'title-h1',
            },
        ],
    },
    block: {
        className: 'content5-img-wrapper',
        gutter: 16,
        children: [
            {
                name: 'block0',
                className: 'block',
                md: 6,
                xs: 24,
                children: {
                    wrapper: {className: 'content5-block-content'},
                    img: {
                        children:
                            'https://t.alipayobjects.com/images/rmsweb/T11aVgXc4eXXXXXXXX.svg'
                    },
                    content: {children: 'Ant Design'},
                },
            },
            {
                name: 'block1',
                className: 'block',
                md: 6,
                xs: 24,
                children: {
                    wrapper: {className: 'content5-block-content'},
                    img: {
                        children:
                            'https://zos.alipayobjects.com/rmsportal/faKjZtrmIbwJvVR.svg',
                    },
                    content: {children: 'Ant Motion'},
                },
            },
            {
                name: 'block2',
                className: 'block',
                md: 6,
                xs: 24,
                children: {
                    wrapper: {className: 'content5-block-content'},
                    img: {
                        children:
                            'https://t.alipayobjects.com/images/rmsweb/T11aVgXc4eXXXXXXXX.svg',
                    },
                    content: {children: 'Ant Design'},
                },
            },
            {
                name: 'block3',
                className: 'block',
                md: 6,
                xs: 24,
                children: {
                    wrapper: {className: 'content5-block-content'},
                    img: {
                        children:
                            'https://zos.alipayobjects.com/rmsportal/faKjZtrmIbwJvVR.svg',
                    },
                    content: {children: 'Ant Motion'},
                },
            },
        ],
    },
};
export const Banner30DataSource = {
    wrapper: {className: 'AboutU_banner3 k0qcuji2xa8-editor_css'},
    textWrapper: {
        className: 'AboutU_banner3-text-wrapper k0qct9r6a-editor_css',
        children: [
            {
                name: 'nameEn',
                className: 'AboutU_banner3-name-en k0qcth162j-editor_css',
                children: (
                    <>
                        <p>About Us</p>
                    </>
                ),
            },
            {
                name: 'slogan',
                className: 'AboutU_banner3-slogan k0qcsufjqz-editor_css',
                children: '关于我们',
                texty: true,
            },

        ],
    },
};
